import React from "react";
import { Routes, Route } from "react-router-dom";
import ScannerForm from "./ScannerForm";
import ResultPage from "./ResultPage";
import ProfileForm from "./ProfileForm";

function App() {
  return (
    <Routes>
      <Route path="/" element={<ProfileForm />} />
      <Route path="/scanner" element={<ScannerForm />} />
      <Route path="/result" element={<ResultPage />} />
    </Routes>
  );
}

export default App;
